<template>
  <div>
    <t-card class="card_common" v-loading="showFlag">
      <div>
        <!-- ボタン -->
        <t-row>
          <t-col :span="8" class="col_common_center">
            <!-- 新規 -->
            <t-button
              round
              type="primary"
              class="button_common"
              ref="addBtn"
              @click="addClick()"
            >
              <i class="el-icon-plus"></i>
              {{ $t("resource.sys.newBuilt") }}
            </t-button>
          </t-col>

          <t-col :span="8" class="col_common_center">
            <!-- 削除 -->
            <t-button
              round
              type="danger"
              class="button_common"
              ref="delBtn"
              @click="deleteClickSelected()"
            >
              <i class="el-icon-delete"></i>
              {{ $t("resource.sys.delete") }}
            </t-button>
          </t-col>
        </t-row>

        <!-- 検索条件 -->
        <div class="div_common_search">
          <t-divider>{{ $t("resource.sys.searchCondition") }}</t-divider>
          <div class="search">
            <t-form
              :model="searchConditionForm"
              :label-width="$t('widgetSize.search.labelWidth')"
            >
              <t-row>
                <t-col :span="1">&nbsp;</t-col>

                <t-col :span="12">
                  <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓ -->
                  <!-- <div style="display: flex; justify-content: start"> -->
                  <!-- 請求日 -->
                  <!-- 課題_支払日と請求日の変更 -->
                  <!-- <t-form-item
                      :label="$t('resource.REQUEST_INFO.REQUEST_DATE')"
                    > -->
                  <div>
                    <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓ -->
                    <!-- 　「請求予定日」⇒「請求期間」の変更 -->
                    <!-- <t-form-item
                      :label="$t('resource.REQUEST_INFO.REQUEST_EXPECTED_DATE')"
                      label-width="$t('widgetSize.COMMON_WIDTH.NINETY_PX')"
                    > -->
                    <t-form-item
                      :label="$t('resource.REQUEST_INFO.REQUEST_PERIOD')"
                    >
                      <!-- UPD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑ -->
                      <!-- <t-date-picker
                        v-model="searchConditionForm.quoteDateRange"
                        type="daterange"
                        :clearable="false"
                        class="date_icon_center"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        style="margin-top: 8px"
                        :editable="false"
                      > -->
                      <t-date-picker
                        v-model="searchConditionForm.quoteDateRange"
                        type="daterange"
                        :clearable="false"
                        class="date_icon_center"
                        range-separator="～"
                        start-placeholder="開始日"
                        end-placeholder="終了日"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        style="margin-left: 0px; width: 60%"
                        :editable="false"
                      >
                        <!-- UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑ -->
                      </t-date-picker>
                    </t-form-item>
                  </div>
                </t-col>
                <t-col :span="5">
                  <!-- 請求状態 -->
                  <t-form-item
                    :label="$t('resource.REQUEST_INFO.REQUEST_STATUS')"
                  >
                    <t-select
                      v-model="searchConditionForm.selectRbStatus"
                      clearable
                      style="width: 100%"
                      :placeholder="$t('resource.sys.hidden')"
                    >
                      <t-option
                        v-for="item in requestStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </t-option>
                    </t-select>
                  </t-form-item>
                </t-col>

                <t-col :span="3">&nbsp;</t-col>
              </t-row>
              <t-row>
                <t-col :span="1">&nbsp;</t-col>

                <t-col :span="17" class="col_block_left">
                  <!-- 検索キー -->
                  <t-form-item :label="$t('resource.sys.searchKey')">
                    <t-input
                      v-model="searchConditionForm.searchWord"
                      clearable
                      maxLength="50"
                      class="input_searchKey1"
                    >
                    </t-input>
                  </t-form-item>
                </t-col>

                <t-col :span="1">&nbsp;</t-col>

                <t-col :span="4" class="center">
                  <!-- 検索 -->
                  <t-button
                    round
                    type="primary"
                    class="button_common_search"
                    @click="searchClick()"
                  >
                    <i class="el-icon-search"></i
                    >{{ $t("resource.sys.search") }}
                  </t-button>
                </t-col>
                <t-col
                  :span="parseInt($t('widgetSize.TRANSPORT.SPACE_SPAN_ONE'))"
                  class="col_block_left"
                  >&nbsp;</t-col
                >
              </t-row>
            </t-form>
          </div>
        </div>
      </div>

      <div class="div_content">
        <t-table
          ref="requestTableData"
          :data="requestTableData"
          class="table_common"
          header-cell-class-name="bg-default"
          @row-dblclick="updateClick"
          :height="maxheight"
          border
        >
          <t-table-column type="selection" class-name="cell_txt_center" />

          <!-- 請求状態 -->
          <t-table-column
            prop="rbRequestStatus"
            :label="$t('resource.REQUEST_INFO.REQUEST_STATUS')"
            :min-width="
              flexColumnWidthFunc(
                $t('resource.REQUEST_INFO.REQUEST_STATUS'),
                'rbRequestStatus'
              )
            "
            class-name="cell_txt_center"
          >
            <template #default="{ row }"
              ><div class="div_status">
                <span :class="row.rbReqStatusColor" class="status">●</span>
                <span class="order-status">{{ row.rbRequestStatusName }} </span>
              </div>
            </template>
          </t-table-column>

          <t-table-column
            v-for="(column, index) in columns"
            :key="index"
            :type="column.type"
            :prop="column.prop"
            :label="column.label"
            :width="column.realWidth"
            :min-width="column.width"
            :class-name="column.class"
            :show-overflow-tooltip="column.overflowTooltip"
          >
          </t-table-column>
        </t-table>

        <t-pagination
          align="right"
          :current-page.sync="pageNo"
          :page-size="pageSize"
          :page-sizes="getPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="tableDatalength"
          @current-change="pageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </div>
    </t-card>
  </div>
</template>


<script>
import { ShowRequestInfoDialog } from "@/components/Dialog";
import { t } from "@/locales";
import { deleteRequestInfo, getRequestBasicInfo } from "@/services/requestInfo";
import {
  formatStringToCurrency,
  getOneMonthAgoArray,
} from "@/utils/comFunction";
import { GetPageDataCount } from "@/utils/const";
import { flexColumnWidth, setColumnWidth } from "@/utils/table";
import { Modal } from "@tellus/component";
//import { DateFormat } from "@/utils/filter";
import { Message } from "@tellus/component";
export default {
  data() {
    return {
      searchConditionForm: {
        // 請求日
        quoteDateRange: "",
        // 請求開始日
        startDate: "",
        //  請求終了日
        endDate: "",
        // 請求状態
        selectRbStatus: "",
        // 検索キー
        searchWord: "",
      },

      requestStatusList: [],

      // 現在のページ数
      pageNo: 1,

      // データ個数/各ページ
      pageSize: 20,

      requestInfoData: [],

      // 待ちダイアログ
      showFlag: true,

      // データ総数
      tableDatalength: 0,
      maxheight: window.innerHeight - 291.5 - 10, //291.5 = 165.5 + 20 + 10 + 58 + 32 + 6

      columns: [
        // 請求予定日
        {
          prop: "rbRequestExpectedDate",
          label: t("resource.REQUEST_INFO.REQUEST_EXPECTED_DATE"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          overflowTooltip: false,
        },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 課題_支払日と請求日の変更
        // 請求日
        // {
        //   prop: "rbRequestDate",
        //   label: t("resource.REQUEST_INFO.REQUEST_DATE"),
        //   width: t("widgetSize.tableCommon.defaultWidth"),
        //   class: "cell_txt_center",
        //   overflowTooltip: false,
        // },
        // DEL 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

        // 得意先
        {
          prop: "rbCusInfo",
          label: t("resource.REQUEST_INFO.CUS_INFO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 請求金額
        {
          prop: "rbAmount",
          label: t("resource.REQUEST_INFO.REQUEST_AMOUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_right",
          overflowTooltip: true,
        },
        // 備考
        {
          prop: "rbRemarks",
          label: t("resource.REQUEST_INFO.BIKOU"),
          realWidth: "180",
          width: "180",
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],
    };
  },

  watch: {
    // 請求日
    "searchConditionForm.quoteDateRange"(value) {
      // 請求日処理
      this.editDate(value);
    },
  },

  computed: {
    requestTableData: {
      get() {
        return this.requestInfoData.slice(
          (this.pageNo - 1) * this.pageSize,
          this.pageNo * this.pageSize
        );
      },
    },

    recordTotal() {
      return this.requestInfoData.length;
    },
  },

  mounted() {
    // 画面の初期化
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    // 初期化
    init() {
      this.dateInit();

      this.searchClick();
    },

    //請求日の初期化
    dateInit() {
      // 請求日
      this.searchConditionForm.quoteDateRange = getOneMonthAgoArray();

      // 請求開始日
      this.searchConditionForm.startDate =
        this.searchConditionForm.quoteDateRange[0];

      // 請求終了日
      this.searchConditionForm.endDate =
        this.searchConditionForm.quoteDateRange[1];
    },

    handleResize() {
      this.maxheight = window.innerHeight - 291.5 - 10;
    },

    // 請求日処理
    editDate(value) {
      if (Array.isArray(value) && value.length >= 2) {
        // 請求開始日
        this.searchConditionForm.startDate = value[0];
        // 請求終了日
        this.searchConditionForm.endDate = value[1];
      } else {
        // 請求開始日
        this.searchConditionForm.startDate = null;
        // 請求終了日
        this.searchConditionForm.endDate = null;
      }
    },

    //データの処理
    dataProcess() {
      if (this.requestInfoData.length >= 1) {
        for (let index = 0; index < this.requestInfoData.length; index++) {
          const element = this.requestInfoData[index];

          if (element.rbAmount != null) {
            //金額(CNY)
            element.rbAmount = formatStringToCurrency(
              parseInt(element.rbAmount)
            );
          }
        }
      }
    },

    // 検索
    searchClick() {
      this.showFlag = true;

      // 検索キー
      this.searchConditionForm.searchWord =
        this.searchConditionForm.searchWord?.trim();

      getRequestBasicInfo(this.searchConditionForm)
        .then((res) => {
          this.requestInfoData = res.RequestBasicInfo;

          this.requestStatusList = res.RequestInfoList;

          this.tableDatalength = this.requestInfoData.length;

          setColumnWidth(this.columns, this.requestInfoData);

          this.dataProcess();

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 新规
    addClick() {
      ShowRequestInfoDialog(
        { isAdd: true },
        t("resource.REQUEST_INFO.DETAIL_DIALOG"),
        (target) => {
          this.searchClick();
        }
      );

      // フォーカス削除
      this.$refs.addBtn.$el.blur();
    },

    //编辑
    updateClick(row) {
      ShowRequestInfoDialog(
        { isAdd: false, RowData: row },
        t("resource.REQUEST_INFO.DETAIL_DIALOG"),
        (target) => {
          this.searchClick();
        }
      );
    },

    //複数行データの削除
    deleteClickSelected() {
      let data = this.$refs.requestTableData.selection;

      // 「請求済み」のデータの削除が不可
      // let hasApproved = data.some(
      //   (item) => item.rbRequestStatus === FINAL_STR.REQUEST_STATUS_END
      // );

      // if (hasApproved) {
      //   Modal.showError(
      //     "",
      //     t("message.REQUEST_INFO.HAS_REQUEST_STATUS_END_MESSAGE"),
      //     {
      //       confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
      //     }
      //   );

      //   return;
      // }

      if (data.length >= 1) {
        Modal.showWarning("", t("resource.sys.deleteMessage"), {
          $type: "prompt",
          confirmButtonText: t("resource.button.sure"),
          cancelButtonText: t("resource.button.cancel"),
          showCancelButton: true,
        })
          .then(() => {
            // 削除請求台帳情報
            deleteRequestInfo(data)
              .then(() => {
                Message.showSuccess(t("message.COMMON_MESSAGE.DELETE_SUCCESS"));

                this.searchClick();
              })
              .catch((error) => {
                if (error.data != null) {
                  Message.showError(
                    t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
                  );
                } else {
                  Message.showError(t("message.COMMON_MESSAGE.DELETE_FAILURE"));
                }
              });
          })
          .catch((error) => {});
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.delBtn.$el.blur();
    },

    // 翻页处理
    pageChange(val) {
      this.pageNo = val;
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
    },
    // 每页数据条数
    getPageDataCountFunc() {
      return GetPageDataCount();
    },

    /**
     * el-table-column 自适应列宽
     * @param prop_label: 表名
     * @param table_data: 表格数据
     */
    flexColumnWidthFunc(label, prop) {
      return flexColumnWidth(label, prop, this.requestTableData);
    },
  },
};
</script>

<style scoped>
.order-status {
  flex: 1; /* 使第二个 span 元素占据剩余空间，实现内容对齐 */
}
</style>

/* ::v-deep .el-form-item__label {
  text-align: left;
  margin-left: 1550px;
} */
